import React, { useEffect } from "react";
import { ElaborationStatusItem } from "../../redux/feature/object/remote-elaborations-slice";
import { OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION } from "../../utils/constants/notification";
import LoadingManager from "../../common/loading/LoadingManager";
import { checkAbortable } from "../../utils/helpers/ElaborationHelper";

interface ObjectPanelWithElaborationProps {
  elaborationItem?: ElaborationStatusItem;
  children: any;
  notificationKey: string;
}

export const ElaborationWrapper: React.FunctionComponent<ObjectPanelWithElaborationProps> = (props) => {
  const { elaborationItem } = props;

  useEffect(() => {
    if (elaborationItem) {
      LoadingManager.create(OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION, {
        isAbortable: checkAbortable(elaborationItem),
        items: [
          {
            correlationId: elaborationItem.correlationId,
            clientId: null,
            documentId: null,
            userId: null,
            items: [elaborationItem],
          },
        ],
      });
    } else {
      LoadingManager.remove(OBJECT_PANEL_WITH_ELABORATION_NOTIFICATION);
    }
  }, [elaborationItem]);

  return props.children;
};
